jQuery(function ($) {
    function titleRow() {
        const $heading = $('.title-row .fl-heading');
        const $wrap = $('.title-row .fl-row-content-wrap');

        if ($heading.length && $wrap.length) {
            const $col = $heading.closest('.fl-col-content');
            const buffer = 40;

            if ($col.length) {
                const height = $col.outerHeight(true); // includes margin
                const offset = -(height + buffer);

                $wrap.css({ 'margin-top': offset + 'px' });
                if ($('#homeSlideshow').length && $(window).width() <= 600) {
                    $('#homeSlideshow .fl-content-slider').css({ 'margin-bottom': (offset * -1) + 'px' });
                }
            }
        }
    }
    $('a[href^="#"]').on('click', function (e) {
        const targetId = $(this).attr('href');
        const $target = $(targetId);

        if ($target.length && $(window).width() >= 992) {
            e.preventDefault();
            $('html, body').stop().animate({
                scrollTop: $target.offset().top - 150
            }, 500);
        }
    });

    titleRow();

    let resizeTimeout;
    $(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(titleRow, 100);
    });
    $(window).on('load', function () {
        const hash = window.location.hash;
        const $target = $(hash);
        if ($target.length) {
            $('html, body').scrollTop($target.offset().top - 150);
        }
    });


});
